import React from "react";
import { Link } from "react-router-dom";
import Breadcrumbs from "../Breadcrumbs/Breadcrumbs.js";

export default function About() {
  return (
    <section className="contacts about">
      <Breadcrumbs />

      <h1 className="contacts__title history__title">Об институте</h1>

      <table className="contacts__table">
        <tbody>
          <tr className="contacts__line">
            <th className="contacts__caption" colSpan={2}>
              Информация об организации
            </th>
          </tr>
          <tr className="contacts__line">
            <td className="contacts__cell">
              Полное наименование (в соответствии с уставов)
            </td>
            <td className="contacts__cell">
              Государственное бюджетное учреждение Свердловской области
              «Уральский научно-исследовательский институт дерматовенерологии и
              иммунопатологии»
            </td>
          </tr>
          <tr className="contacts__line">
            <td className="contacts__cell">
              Сокращенное наименование (в соответствии с уставом)
            </td>
            <td className="contacts__cell">ГБУ СО «УрНИИДВиИ»</td>
          </tr>
          <tr className="contacts__line">
            <td className="contacts__cell">Место нахождения</td>
            <td className="contacts__cell">
              г. Екатеринбург, ул. Щербакова, 8
            </td>
          </tr>
          <tr className="contacts__line">
            <td className="contacts__cell">Почтовый адрес</td>
            <td className="contacts__cell">
              620076, Россия, г. Екатеринбург, ул. Щербакова, 8
            </td>
          </tr>
          <tr className="contacts__line">
            <td className="contacts__cell">Адрес электронной почты</td>
            <td className="contacts__cell contacts__mail">
              <a
                href="mailto:urniidvi-public@mis66.ru"
                className="contacts__table-tel"
              >
                urniidvi-public@mis66.ru
              </a>
            </td>
          </tr>
          <tr className="contacts__line">
            <td className="contacts__cell">
              ФИО и должность руководителя организации
            </td>
            <td className="contacts__cell">
              Кунгуров Николай Васильевич <br></br>директор ГБУ СО «УрНИИДВиИ»,
              Заслуженный врач РФ, доктор медицинских наук, профессор
            </td>
          </tr>
        </tbody>
      </table>

      <div className="footer__middle_block">
        <Link to="/about/history" className="footer__link">
          История института
        </Link>
        <Link to="/about/structure" className="footer__link">
          Структура института
        </Link>
        <Link to="/about/licenses" className="footer__link">
          Правовая информация и лицензии
        </Link>
        <Link to="/about/privacy" className="footer__link">
          Политика конфиденциальности
        </Link>
        <Link to="/about/anti-corruption" className="footer__link">
          Противодействие коррупции
        </Link>
        <Link to="/about/anti-terror" className="footer__link">
          Антитеррористическая безопасность
        </Link>
        <Link to="/about/controls" className="footer__link">
          Органы управления
        </Link>
        <Link to="/about/vacancies" className="footer__link">
          Вакансии
        </Link>
        <Link to="/about/news" className="footer__link">
          Новости
        </Link>
        <Link to="/about/sitemap" className="footer__link">
          Карта сайта
        </Link>
        <Link to="/about/working-conditions" className="footer__link">
          Условия труда
        </Link>
        <Link to="/about/accounting-policy" className="footer__link">
          Учетная политика
        </Link>
        <Link to="/about/independent-assessment" className="footer__link">
          Независимая оценка качества
        </Link>
        <Link to="/about/heating-season" className="footer__link">
          Подготовка к отопительному сезону
        </Link>
      </div>
    </section>
  );
}
